import type { ReactNode } from 'react';
import { Flex, Heading, Text } from '@highereducation/hen-ui';

interface NoResultsProps {
  illustration?: ReactNode;
}

const NoResults = ({ illustration }: NoResultsProps) => (
  <Flex
    className='mx-auto max-w-4xl px-4 py-16 md:gap-12'
    data-testid='no-results'
    direction='column'
    direction-md='row'
    align='center'
    gap='2xl'
  >
    {illustration}
    <Flex className='w-full md:w-auto' direction='column' gap='sm'>
      <Heading variant='h2'>
        We couldn&apos;t find a direct match for your search
      </Heading>
      <Text variant='b4' color='default'>
        Try updating or clearing all of your selected filters.
      </Text>
    </Flex>
  </Flex>
);

export { NoResults };
